import * as issueCategories from "./issueCategories";
import i18n from "@/common/lang.serivce";

const IssueCategories = {
  list() {
    return Object.keys(issueCategories);
  },
  getAll() {
    return this.list().map(issueCategory => {
      return {
        value: issueCategory,
        text: i18n.t("issueCategories." + issueCategory)
      };
    });
  }
};

export default IssueCategories;
